import React from 'react';
import { useLocation } from 'react-router-dom';
import { prop } from 'ramda';
import Overlay from '@core/js/components/common/Overlay';
import { useUpdateEffect } from '@core/js/hooks/useUpdateEffect';
import { useDeviceSelector, useMyAccountSidebarSelector } from '@core/js/store/hooks';
import { useCallbackOnLogout } from '@core/js/hooks/useCallbackOnLogout';

import * as hooks from '@core/js/components/main/MyAccountSidebar/hooks';
import { Header } from './components/Header';
import { Content } from '@core/js/components/main/MyAccountSidebar/components/Content';

import style from './MyAccountSidebar.scss';

export const MyAccountSidebar = () => {
    const location = useLocation();
    const handleSidebarClose = hooks.useHandleSidebarClose();
    const isOpened = useMyAccountSidebarSelector(prop('isOpened'));
    const isOpenedClass = isOpened ? style.opened : '';
    const isMobile = useDeviceSelector(prop('isMobile')); /* Lugano changes */

    useUpdateEffect(() => {
        handleSidebarClose();
    }, [location.pathname, handleSidebarClose]);

    useCallbackOnLogout(handleSidebarClose);

    return (
        <>
            <div className={`${style.sidebar} ${isOpenedClass} ${isMobile ? style['right'] : style['left']} cms-my-account-sidebar`} /* Lugano changes */ >
                {isOpened && (
                    <>
                        <Header/>
                        <Content/>
                    </>
                )}
            </div>
            {isOpened && (
                <Overlay
                    className={style.overlay}
                    onClick={handleSidebarClose}
                />
            )}
        </>
    );
};
